<template >
<v-layout column="" class="px-0 b lighten-1">  
    <v-layout class="b1 py-0 my-0" row wrap >
        <v-container grid-list-xs class=" py-0 my-0">
            <br>
            <v-card class="px-5">
                <br><br>
                <v-row class=" b py-0 my-0">
                    <v-col>
                        <v-layout   align-center="" justify-center="" fill-height="">
                            <div class="not-f10 font-weight-bold primary--text not-shadow text-center">
                                Religious Formation
                            </div>   
                            <v-spacer></v-spacer> 
                        </v-layout> 
                    </v-col> 
                    <v-col class=" py-0 my-0" sm="6">
                        <v-layout justify-center="">
                            
                        </v-layout>
                    </v-col>
                    
                </v-row>
                <hr>
                <br> 
                <div class="text-justify"> 
                    <br>
                    <p>
                        Life is a journey consisting in various stages. The same is true of a commitment to give one's life to God. The formation period is of paramount importance.
                    </p>
                    <br>
                    <div class="not-f7 font-weight-bold">{{not.TEXT_UP("Formation Steps")}}</div>
                    <br>
                     <v-row>
                         <v-col sm="6" v-for="(step, index) in formationSteps" :key="index">
                            <v-card height="100%" hover="" tile="" flat="">
                                <v-img aspect-ratio="2" v-if="step.image" :src="step.image"></v-img> 
                                <v-img aspect-ratio="2" v-else :src="not.noImg"></v-img> 

                                <v-card-text>
                                    <div class="not-f7 font-weight-bold pb-2">{{step.title}}</div>
                                    <div v-for="(line, index) in not.TEXT_SPLIT_N(step.body)" :key="index">{{line}}</div> 
                                </v-card-text>
                            </v-card>
                         </v-col>
                     </v-row>


 
                    <br><br><br><br>

                </div>
            </v-card>
            <br><br>
        </v-container> 
    </v-layout> 
    
</v-layout>
</template>

<script>
    let pageName = "About"
    export default{
        props:["not"],
        name: pageName,  
        data: () => ({
            show: false,  
            message: '',
            images:[
                {src:'/images/teresian/t18.JPG',local:true},  
            ],
            formationSteps:[
                {title:'Aspirancy',body:"Aspirancy is the first stage of religious life, the purpose of this stage is to help the candidate achieve her desire to join religious life and deepen Christian values and attain holistic growth. \n 1. The aspirants shall be a Catholic, baptized and confirmed \n2. One who has never attempted marriage \n 3. A simple ceremony shall mark this stage e.g. receiving of medals \n 4. Vocation animators from their nearby community shall visit them from time to time. \n\n  Procedure to be followed at the end of Aspirancy stage \n At the end of the Aspirancy stage the directress assesses the suitability and motives of the aspirants. She also informs them of the congregation’s requirements.",image:'./images/teresian/formation/step-aspirancy.JPG'},

                {title:'Pre-postulate',body:'During pre-postulate the girls who passed their MSCE or professional training shall stay for a period of 6 to 9 months at a place designated for the purpose by the congregation. Girls start their discernment process under the guidance of their mistress. They are oriented on the basics of religious life.',image:'/images/teresian/formation/step-pre-postulate.jpeg'},

                {title:'The postulate',body:'Before entering the novitiate, you experience a stage that promotes continuity in your search for God\'s will. Working with a mentor appointed by the Superior General, you ascertain the signs of your call, your motivations and your ability to make decisions freely. Duration of the postulate is one Year it can be extended if need be.',image:'/images/teresian/formation/step-postulate.jpeg'},

                {title:'The Novitiate',body:"The novitiate is the stage where you are initiated to the radical demands of religious life and intimacy with Christ. You are now free to listen to the Lord speak to your heart and to let yourself be transformed by His love. You are introduced to community life and the life of prayer. You take courses that allow you to get to know the Foundress better, to deepen the spirituality and the charism of the Institute, to grasp the meaning of each of the vows that you will be taking. Apostolic internships are offered. The novitiate lasts two years.",image:'/images/teresian/formation/step-novitiate.jpeg'},

                {title:'Temporary Commitment',body:'After the novitiate, you take vows of poverty, chastity and obedience that you will renew each year for a period of eight years or more.',image:'/images/teresian/formation/step-temporary-commitment.JPG'},

                {title:'Final Commitment',body:'At the end of the period for temporary vows. You manifest the desire to make perpetual profession by sending a letter of request to the Superior General. Through this commitment, you express the total and definitive gift of yourself to God the Father, following Jesus, in the service of the Church in the Congregation of the Teresian Sisters.',image:''},

                {title:'Continuing Formation',body:'Throughout our life, this initial YES must be repeated a Teresian sister shall seek the means that help not only to improve her skills for a better apostolic performance, but also to nourish a more ardent spiritual life.',image:'/images/teresian/formation/step-continuing-formation.jpeg'}, 
            ]
        }),
        mounted() {
            this.not.NotHeaderNT({
            notShow:true,
            notType:"image",
            notImages:this.images,
            notText:false,
            notIndicators:true,
            notHeight:350
        })
        },
        //---------computed-----------
        computed: { 
           us(){
                return this.not.us
            },
            loading(){  
                return this.not.loading
            },
            processes(){  
                return this.not.processes
            }, 
            responses(){  
                return this.not.responses
            },
            congregations(){
                return this.$store.getters.getCongregation
            },
              
        },

        //--------methods-----------
        methods:{
        
        }, 
    } 
    
</script>

 